import type { IPermanentSignal, SignalFilters, Signal } from "../signal";

/**
 * Type guard to check if a signal is a permanent signal
 *
 * @param signal - Signal to check
 * @returns True if signal is permanent
 *
 * @example
 * ```typescript
 * if (isPermanentSignal(signal)) {
 *   // signal.expiresAt would be an error
 * }
 * ```
 */
function isPermanentSignal<Filters extends SignalFilters = SignalFilters>(
    signal: Signal<Filters>,
): signal is IPermanentSignal<Filters> {
    return signal.lifecycleStatus === "permanent";
}

export default isPermanentSignal;
